import { ResultLayer } from "./ResultLayer";
import { TurretsList } from "./TurretsList";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { MapObject } from "../../../types/tower-defense";
import { WavesList } from "./WavesList";
import { GameVars } from "../../GameVars";
import { Bot } from "./Bot";

export class LevelFileScene extends Phaser.Scene {

    private mapData: MapObject;
    private pathCounter: number;
    private index: number;

    private pathText: Phaser.GameObjects.Text;
    private botBtn: Phaser.GameObjects.Graphics;
    private botText: Phaser.GameObjects.Text;

    private wavesList: WavesList;
    private resultLayer: ResultLayer;

    private coinsInput: any;
    private canScroll: boolean;

    private canUpdate: boolean;

    constructor() {

        super("LevelFileScene");
    }

    public create(): void {

        GameVars.currentScene = this;

        this.cameras.main.setBackgroundColor(0x6cd9b2);

        this.index = GameVars.editorIndex;

        this.mapData = GameManager.generateMapData("map_" + this.index);

        let height = 385 + this.mapData.paths.length * 10 * 22 + 10 * 4;

        let fileContainer = new Phaser.GameObjects.Container(this);
        fileContainer.setPosition(20, 90);
        this.add.existing(fileContainer);

        let downloadBtn = new Phaser.GameObjects.Graphics(this);
        downloadBtn.setPosition(GameConstants.GAME_WIDTH / 2 - 20, - 45);
        downloadBtn.fillStyle(0xffffff);
        downloadBtn.fillRoundedRect(-75, -25, 150, 50, 5);
        downloadBtn.lineStyle(5, 0x000000);
        downloadBtn.strokeRoundedRect(-75, -25, 150, 50, 5);
        downloadBtn.setInteractive(new Phaser.Geom.Rectangle(-75, -25, 150, 50), Phaser.Geom.Rectangle.Contains);
        downloadBtn.on("pointerdown", this.onClickDownload, this);
        fileContainer.add(downloadBtn);

        let downloadText = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2 - 20, - 45,  "DOWNLOAD", {fontFamily: "Rubik-Regular", fontSize: "25px", color: "#000000", align: "center"});
        downloadText.setOrigin(.5);
        fileContainer.add(downloadText);

        let lobbyBtn = new Phaser.GameObjects.Graphics(this);
        lobbyBtn.setPosition(75, - 45);
        lobbyBtn.fillStyle(0xffffff);
        lobbyBtn.fillRoundedRect(-75, -25, 150, 50, 5);
        lobbyBtn.lineStyle(5, 0x000000);
        lobbyBtn.strokeRoundedRect(-75, -25, 150, 50, 5);
        lobbyBtn.setInteractive(new Phaser.Geom.Rectangle(-75, -25, 150, 50), Phaser.Geom.Rectangle.Contains);
        lobbyBtn.on("pointerdown", this.onClickLobby, this);
        fileContainer.add(lobbyBtn);

        let lobbyText = new Phaser.GameObjects.Text(this, 75, - 45,  "EDITOR\nSCENE", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#000000", align: "center"});
        lobbyText.setOrigin(.5);
        fileContainer.add(lobbyText);

        const bck = new Phaser.GameObjects.Graphics(this);
        bck.fillStyle(0xFFFFFF);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH - 40, height);
        fileContainer.add(bck);

        let levelText = new Phaser.GameObjects.Text(this, 25, 8,  "LEVEL " + this.index, {fontFamily: "Rubik-Bold", fontSize: "30px", color: "#000000", align: "center"});
        fileContainer.add(levelText);

        this.time.addEvent({ delay: 100, callback: () => {

            let renderTextureMap = this.generateRenderTexture();
            renderTextureMap.setScale(.19);
            renderTextureMap.setPosition(10, 45);
            fileContainer.add(renderTextureMap);

            let imgWaves = new Phaser.GameObjects.Image(this, 10, 200, "texture_atlas_0", "enemies");
            imgWaves.setOrigin(0);
            imgWaves.setScale(.6);
            fileContainer.add(imgWaves);

            this.pathText = new Phaser.GameObjects.Text(this, 12, 45,  "1", {fontFamily: "Rubik-Bold", fontSize: "20px", color: "#ff0000", align: "center"});
            fileContainer.add(this.pathText);

            this.botBtn = new Phaser.GameObjects.Graphics(this);
            this.botBtn.setPosition(520, 300);
            this.botBtn.fillStyle(0xffffff);
            this.botBtn.fillRoundedRect(-75, -25, 150, 50, 5);
            this.botBtn.lineStyle(5, 0x000000);
            this.botBtn.strokeRoundedRect(-75, -25, 150, 50, 5);
            this.botBtn.setInteractive(new Phaser.Geom.Rectangle(-75, -25, 150, 50), Phaser.Geom.Rectangle.Contains);
            this.botBtn.on("pointerdown", this.onClickBot, this);
            fileContainer.add(this.botBtn);

            this.botText = new Phaser.GameObjects.Text(this, 520, 300,  "PLAY BOT", {fontFamily: "Rubik-Regular", fontSize: "25px", color: "#000000", align: "center"});
            this.botText.setOrigin(.5);
            fileContainer.add(this.botText);

            let playBtn = new Phaser.GameObjects.Graphics(this);
            playBtn.setPosition(350, 300);
            playBtn.fillStyle(0xffffff);
            playBtn.fillRoundedRect(-75, -25, 150, 50, 5);
            playBtn.lineStyle(5, 0x000000);
            playBtn.strokeRoundedRect(-75, -25, 150, 50, 5);
            playBtn.setInteractive(new Phaser.Geom.Rectangle(-75, -25, 150, 50), Phaser.Geom.Rectangle.Contains);
            playBtn.on("pointerdown", this.onClickPlay, this);
            fileContainer.add(playBtn);

            let playText = new Phaser.GameObjects.Text(this, 350, 300,  "PLAY", {fontFamily: "Rubik-Regular", fontSize: "30px", color: "#000000", align: "center"});
            playText.setOrigin(.5);
            fileContainer.add(playText);

            this.resultLayer = new ResultLayer(this, this.index);
            fileContainer.add(this.resultLayer);

            this.wavesList = new WavesList(this, this.mapData);
            fileContainer.add(this.wavesList);
            
            let turretsList = new TurretsList(this, this.index);
            fileContainer.add(turretsList);

            let coinsText = new Phaser.GameObjects.Text(this, 560, 150, "COINS", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#000000", align: "center"});
            coinsText.setOrigin(.5);
            fileContainer.add(coinsText);

            let coinsElement = this.add.dom(560, 180).createFromCache("initial-coins");
            fileContainer.add(coinsElement);

            this.coinsInput = coinsElement.getChildByName("initialCoins");
            this.coinsInput.value = GameVars.wavesInfo[this.mapData.name].initialCoins || "0";

            let specialAttacks = new Phaser.GameObjects.Container(this);
            specialAttacks.setPosition(400, 150);
            fileContainer.add(specialAttacks);

            let pigImage = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "presentation_skill_pig");
            pigImage.setScale(.12);
            specialAttacks.add(pigImage);

            let checkbox = new Phaser.GameObjects.Image(this, 40, 0, "texture_atlas_0", "checkbox_" + (GameVars.gameData.levelsInfo[this.index].specials[0] ? "on" : "off"));
            checkbox.setInteractive();
            checkbox.on("pointerdown", () => {
                if (checkbox.frame.name === "checkbox_on") {
                    checkbox.setFrame("checkbox_off");
                    GameVars.gameData.levelsInfo[this.index].specials[0] = false; 
                } else {
                    checkbox.setFrame("checkbox_on");
                    GameVars.gameData.levelsInfo[this.index].specials[0] = true;
                }
                GameManager.writeGameData();
            }, this);
            specialAttacks.add(checkbox);

            let freezeImage = new Phaser.GameObjects.Image(this, 0, 45, "texture_atlas_1", "presentation_skill_freeze");
            freezeImage.setScale(.11);
            specialAttacks.add(freezeImage);

            let checkbox2 = new Phaser.GameObjects.Image(this, 40, 45, "texture_atlas_0", "checkbox_" + (GameVars.gameData.levelsInfo[this.index].specials[1] ? "on" : "off"));
            checkbox2.setInteractive();
            checkbox2.on("pointerdown", () => {
                if (checkbox2.frame.name === "checkbox_on") {
                    checkbox2.setFrame("checkbox_off");
                    GameVars.gameData.levelsInfo[this.index].specials[1] = false; 
                } else {
                    checkbox2.setFrame("checkbox_on");
                    GameVars.gameData.levelsInfo[this.index].specials[1] = true;
                }
                GameManager.writeGameData();
            }, this);
            specialAttacks.add(checkbox2);

            let presetText = new Phaser.GameObjects.Text(this, 310, 170, "USE PREV\nTURRETS", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#000000", align: "right"});
            presetText.setOrigin(1, .5);
            fileContainer.add(presetText);

            let checkbox3 = new Phaser.GameObjects.Image(this, 335, 170, "texture_atlas_0", "checkbox_" + (GameVars.usePrevTurrets ? "on" : "off"));
            checkbox3.setInteractive();
            checkbox3.on("pointerdown", () => {
                if (checkbox3.frame.name === "checkbox_on") {
                    checkbox3.setFrame("checkbox_off");
                    GameVars.usePrevTurrets = false;
                } else {
                    checkbox3.setFrame("checkbox_on");
                    GameVars.usePrevTurrets = true;
                }
                GameManager.writeGameData();
            }, this);
            fileContainer.add(checkbox3);

            this.canUpdate = true;

        }, callbackScope: this});

        this.canScroll = false;

        this.input.on("pointerdown", () => {
            this.canScroll = true;
        }, this);

        this.input.on("pointerup", () => {
            this.canScroll = false;
        }, this);

        this.input.on("pointerout", () => {
            this.canScroll = false;
        }, this);

        this.input.on("wheel", (pointer: Phaser.Input.Pointer, dx: any, dy: any, dz: any) => {
            fileContainer.y -= dz;

            if (fileContainer.y > 90) {
                fileContainer.y = 90;
            }

            if (fileContainer.y < Math.min (-height + GameConstants.GAME_HEIGHT - 20, 90)) {
                fileContainer.y = Math.min (-height + GameConstants.GAME_HEIGHT - 20, 90);
            }
        }, this);

        this.input.on("pointermove", (pointer: Phaser.Input.Pointer) => {
            if (this.canScroll) {
                fileContainer.y += (pointer.position.y - pointer.prevPosition.y);

                if (fileContainer.y > 90) {
                    fileContainer.y = 90;
                }
    
                if (fileContainer.y < Math.min (-height + GameConstants.GAME_HEIGHT - 20, 90)) {
                    fileContainer.y = Math.min (-height + GameConstants.GAME_HEIGHT - 20, 90);
                }
            }
        }, this);
        
    }

    public update(time: number, delta: number): void {

        if (this.canUpdate) {
            this.saveWaves();
        }
    }

    private onClickPlay(): void {

        this.canUpdate = false;

        GameManager.enterBattleScene(this.mapData.name, Math.max(0, Math.floor((this.index - 1) / 6)), (this.index - 1) % 6); 
    }

    private onClickBot(): void {

        this.botBtn.input.enabled = false;
        this.botBtn.alpha = 0;
        this.botText.alpha = 0;

        this.time.addEvent({ delay: 100, callback: () => {

            GameVars.currentMapData = GameManager.generateMapData(this.mapData.name);
            GameVars.currentMapZone = Math.floor(this.index / 6);
            GameVars.currentMapCount = this.index % 6;

            let result = Bot.play(this.index);

            GameVars.gameData.levelsInfo[this.index].stars = result.stars;
            GameVars.gameData.levelsInfo[this.index].lives = result.lifes;
            GameVars.gameData.levelsInfo[this.index].coins = result.credits;
            GameVars.gameData.levelsInfo[this.index].ticks = result.ticks;
            GameVars.gameData.levelsInfo[this.index].round = result.round;
            GameManager.writeGameData();

            this.resultLayer.setResult(result);

            this.botBtn.input.enabled = true;
            this.botBtn.alpha = 1;
            this.botText.alpha = 1;
        }, callbackScope: this});
    }

    private saveWaves(): void {
        
        let wavesStrings = this.wavesList.getWavesStrings();

        let count = 0;

        let waveData: any = {};
        waveData.initialCoins = parseInt(this.coinsInput.value);
        waveData.waves = {};

        let paths = this.mapData.paths.length;
        let path = 0;
        let numWave = 0;

        while (count < wavesStrings.length) {

            numWave = Math.floor(count / paths) + 1;
            path = count % paths;

            if (!waveData.waves["wave_" + numWave]) {
                waveData.waves["wave_" + numWave] = { 
                    waveReward: 0,
                    strings: [],
                    enemies: []
                };
            }

            waveData.waves["wave_" + numWave].strings.push(wavesStrings[count]);

            for (let i = 0; i < wavesStrings[count].length; i++) {

                let types = GameVars.getTypefromID(wavesStrings[count][i]);

                if (types) {

                    let enemyData = {
                        path: path,
                        type: types.type,
                        subtype: types.subtype,
                        t: i * 5
                    };

                    waveData.waves["wave_" + numWave].enemies.push(enemyData);
                }
            }

            waveData.waves["wave_" + numWave].enemies.sort((a, b) => (a.t > b.t) ? 1 : -1);
            count++;

            if (path === paths - 1) {
                if (waveData.waves["wave_" + numWave].enemies.length === 0) {
                    delete waveData.waves["wave_" + numWave];
                    break;
                }
            }
        }

        GameVars.wavesInfo[this.mapData.name] = waveData;
    }

    private generateRenderTexture(): Phaser.GameObjects.RenderTexture {

        const renderTexture = this.add.renderTexture(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        const map = this.make.tilemap({ key: this.mapData.name });

        const num = this.index === 0 ? 1 : Math.ceil(this.index / 6);
        const tileset = map.addTilesetImage("tileset" + num);

        const background = map.createStaticLayer("background", tileset, - GameConstants.CELLS_SIZE, 0);
        background.visible = false;
        renderTexture.draw(background);

        const foreground1 = map.createStaticLayer("foreground_1", tileset, - GameConstants.CELLS_SIZE, 0);
        foreground1.visible = false;
        renderTexture.draw(foreground1);

        const foreground2 = map.createStaticLayer("foreground_2", tileset, - GameConstants.CELLS_SIZE, 0);
        foreground2.visible = false;
        renderTexture.draw(foreground2);

        for (let i = 0; i < this.mapData.plateaus.length; i++) {

            const img = this.add.sprite(GameConstants.CELLS_SIZE * this.mapData.plateaus[i].c + GameConstants.CELLS_SIZE / 2, (GameConstants.CELLS_SIZE * this.mapData.plateaus[i].r + GameConstants.CELLS_SIZE / 2) - 12, "texture_atlas_1", "flag_build_1");
            img.visible = false;
            img.setTint(0xff0000);
            renderTexture.draw(img);
        }

        this.pathCounter = 0;

        let paths = [];

        for (let i = 0; i < this.mapData.paths.length; i ++) {

            const path = new Phaser.GameObjects.Graphics(this);
            path.lineStyle(10, 0xFF0000);

            for (let j = 0; j < this.mapData.paths[i].path.length - 1; j ++) {

                let x = (this.mapData.paths[i].path[j].c + .5) * GameConstants.CELLS_SIZE;
                let y = (this.mapData.paths[i].path[j].r + .5) * GameConstants.CELLS_SIZE;
                
                path.moveTo(x, y);

                x = (this.mapData.paths[i].path[j + 1].c + .5) * GameConstants.CELLS_SIZE;
                y = (this.mapData.paths[i].path[j + 1].r + .5) * GameConstants.CELLS_SIZE;

                path.lineTo(x, y);
                path.stroke();
            }

            paths.push(path);
        }

        for (let i = 0; i < this.mapData.paths.length; i++) {
            renderTexture.erase(paths[i]);
        }

        renderTexture.draw(paths[this.pathCounter]);
        
        this.time.addEvent({ delay: 1000, callback: () => {

            for (let i = 0; i < this.mapData.paths.length; i++) {
                renderTexture.erase(paths[i]);
            }

            renderTexture.draw(paths[this.pathCounter]);
            this.pathText.setText((this.pathCounter + 1).toString());

            this.pathCounter++;
            if (this.pathCounter === this.mapData.paths.length) {
                this.pathCounter = 0;
            }

        }, callbackScope: this, loop: true});

        return renderTexture;
    }

    private onClickDownload(): void {
        
        let  zone = Math.max(0, Math.floor((this.index - 1) / 6));
        let data = GameManager.getDownloadData(zone);
        let bl = new Blob([data], {
            type: "text/html"
        });
        let a = document.createElement("a");
        a.href = URL.createObjectURL(bl);
        a.download = "waves_" + (zone + 1) + ".json";
        a.hidden = true;
        document.body.appendChild(a);
        a.innerHTML = "someinnerhtml";
        a.click();
    }

    private onClickLobby(): void {

        this.canUpdate = false;

        GameManager.enterLevelsEditorScene();
    }
}
